import keys from '@/config/keys'

// All tracking parameters the backend expects
const TRACKING_PARAMS = [
	'utm_source',
	'utm_medium',
	'utm_campaign',
	'utm_content',
	'utm_term',
	'gclid',
	'fbclid',
]

/**
 * Call once on app load. Reads tracking params from the landing URL and
 * persists them to localStorage so they survive in-app navigation.
 * Only writes when at least one param is present — never clears a previous
 * attribution with an empty set.
 */
export const captureAndSaveTrackingParams = (search = window.location.search) => {
	const urlParams = new URLSearchParams(search)
	const captured = {}

	TRACKING_PARAMS.forEach((key) => {
		const val = urlParams.get(key)
		if (val) captured[key] = val
	})

	if (Object.keys(captured).length > 0) {
		try {
			localStorage.setItem(keys.UTM_TRACKING_PARAMS, JSON.stringify(captured))
		} catch {
			// localStorage unavailable (e.g. Safari private mode) — skip silently
		}
	}
}

/**
 * Returns the stored tracking params object ready to spread into a POST body.
 * Returns an empty object if nothing has been captured yet.
 */
export const getStoredTrackingParams = () => {
	try {
		return JSON.parse(localStorage.getItem(keys.UTM_TRACKING_PARAMS) || '{}')
	} catch {
		return {}
	}
}
